import axios from 'axios'

/**
 * Trigger a browser download for a Blob/File (replaces js-file-download).
 */
export function downloadBlob(data, filename, mime) {
  const blob =
    data instanceof Blob
      ? data
      : new Blob([data], mime ? { type: mime } : undefined)
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.setAttribute('download', filename || 'download')
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}

export const handleDownload = (url, filename) => {
  axios
    .get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      downloadBlob(res.data, filename)
    })
}
